import { ICriteria } from "src/app/core/services/criteria.interface";
import { HttpParams } from "@angular/common/http";

export class LiftModuleCriteria implements ICriteria {
  pageSize: number = 10;
  page: number = 1;
  orderby: string = 'Code asc';
  searchTerm: string = null;

  paramsExport(): HttpParams {
    let params = new HttpParams()
      .set('page', String(this.page))
      .set('orderby', this.orderby)
      .set('pageSize', String(this.pageSize));

    if (this.searchTerm) {
      params = params.set('filter', 'Code.Contains("' + this.searchTerm + '")')
    }

    return params;
  }
}
